import { SvgIconProps } from '@mui/material';
import { useFeatureFlag } from 'providers';
import ChocolateDessertImage from 'assets/images/img-chocolate-dessert.jpg';
import ChocolateCheesecakeImage from 'assets/images/img-chocolate-cheesecake.jpg';

const ChocolateDessert = ({ height = '190', width = '192', className }: SvgIconProps) => {
  const allowSpinToWin = useFeatureFlag('allowSpinToWin');
  return (
    <>
      {allowSpinToWin ? (
        <svg
          height={height}
          width={width}
          viewBox="-20 0 192 190"
          fill="none"
          className={className}
        >
          <path
            d="M13.7457 134.733C-1.94689 109.085 -4.98278 75.1088 8.70026 47.0966C12.3943 39.5333 18.0625 33.1398 23.864 27.0576C30.8368 19.7424 38.2326 12.632 47.066 7.75915C67.1382 -3.31806 101.077 -0.533003 122.579 3.85534C229.615 25.7143 207.286 214.362 93.9323 187.362C74.06 182.627 56.0601 172.121 38.922 160.953C28.6157 154.233 20.1309 145.173 13.7457 134.733Z"
            fill="url(#chocolateDessert_svg_a)"
          />
          <defs>
            <pattern
              id="chocolateDessert_svg_a"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use xlinkHref="#chocolateDessert_svg_b" transform="scale(0.00203666 0.00207039)" />
            </pattern>
            <image
              id="chocolateDessert_svg_b"
              width="491"
              height="483"
              xlinkHref={ChocolateDessertImage}
            />
          </defs>
        </svg>
      ) : (
        <svg
          height={height}
          width={width}
          viewBox="-20 0 192 190"
          fill="none"
          className={className}
        >
          <path
            d="M13.7457 134.733C-1.94689 109.085 -4.98278 75.1088 8.70026 47.0966C12.3943 39.5333 18.0625 33.1398 23.864 27.0576C30.8368 19.7424 38.2326 12.632 47.066 7.75915C67.1382 -3.31806 101.077 -0.533003 122.579 3.85534C229.615 25.7143 207.286 214.362 93.9323 187.362C74.06 182.627 56.0601 172.121 38.922 160.953C28.6157 154.233 20.1309 145.173 13.7457 134.733Z"
            fill="url(#chocolateCheesecake_svg_a)"
          />
          <defs>
            <pattern
              id="chocolateCheesecake_svg_a"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#chocolateCheesecake_svg_b"
                transform="translate(0 -0.257895) scale(0.0005 0.000505263)"
              />
            </pattern>
            <image
              id="chocolateCheesecake_svg_b"
              width="2000"
              height="3000"
              xlinkHref={ChocolateCheesecakeImage}
            />
          </defs>
        </svg>
      )}
    </>
  );
};

export default ChocolateDessert;
